import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { CheckCircle2 } from 'lucide-react';
export function SixTomos() {
  const tomos = [{
    emoji: '🟡',
    title: 'Tomo 1 — El Manual Maestro: El ADN del Alma',
    desc: 'Descubrí la personalidad profunda de tu hijo según su elemento dominante: Fuego, Tierra, Aire o Agua.',
    badge: 'BASE FUNDAMENTAL',
    colorClass: 'bg-yellow-50 border-yellow-200',
    badgeClass: 'bg-yellow-200 text-yellow-800'
  }, {
    emoji: '🩷',
    title: 'Tomo 2 — El Refugio Emocional',
    desc: 'Aprendé a leer sus emociones y a acompañarlo en el desborde sin perder la calma.',
    badge: 'MÁS DESCARGADO',
    colorClass: 'bg-pink-50 border-pink-200',
    badgeClass: 'bg-pink-200 text-pink-800'
  }, {
    emoji: '🟠',
    title: 'Tomo 3 — El Código del Aprendizaje',
    desc: 'Entendé cómo procesa la información tu hijo y acabá con las peleas por la tarea para siempre.',
    colorClass: 'bg-orange-50 border-orange-200'
  }, {
    emoji: '🟢',
    title: 'Tomo 4 — El Lenguaje del Afecto',
    desc: 'Descubrí su lenguaje de amor único y conectá con él de una forma que él realmente siente.',
    colorClass: 'bg-green-50 border-green-200'
  }, {
    emoji: '🔴',
    title: 'Tomo 5 — El Diccionario de Berrinches',
    desc: '100 conductas desafiantes con su necesidad oculta y la frase exacta que tenés que decirle.',
    badge: 'FAVORITO DE LAS MAMÁS',
    colorClass: 'bg-red-50 border-red-200',
    badgeClass: 'bg-red-200 text-red-800'
  }, {
    emoji: '⭐',
    title: 'Tomo 6 — El Oráculo de la Maternidad',
    desc: 'Tu guía completa de conexión profunda, límites conscientes y vínculo a largo plazo.',
    colorClass: 'bg-amber-50 border-amber-200'
  }];
  const checklist = ['Guía completa lista para usar', 'Ejercicios prácticos aplicables desde hoy', 'Frases exactas para cada situación', 'Tablas por elemento y por edad', 'Fichas de seguimiento del vínculo', 'Material 100% en español latinoamericano', 'Adaptado a la crianza real, no a la ideal'];
  return <SectionWrapper data-id="element-236">
      <h2 className="text-4xl md:text-6xl font-serif text-center text-burgundy mb-16" data-id="element-237">
        🌟 LOS 6 TOMOS
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-238">
        {tomos.map((tomo, i) => <div key={i} className={`${tomo.colorClass} border rounded-2xl p-8 relative shadow-sm hover:shadow-md transition-shadow`} data-id="element-239">
            {tomo.badge && <span className={`absolute -top-3 right-6 px-3 py-1 rounded-full text-xs font-bold tracking-wider ${tomo.badgeClass}`} data-id="element-240">
                {tomo.badge}
              </span>}
            <div className="text-4xl mb-4" data-id="element-241">{tomo.emoji}</div>
            <h3 className="text-xl md:text-2xl font-bold text-text-main mb-3" data-id="element-242">
              {tomo.title}
            </h3>
            <p className="text-text-main/80 leading-relaxed" data-id="element-243">{tomo.desc}</p>
          </div>)}
      </div>

      <div className="bg-white p-8 md:p-12 rounded-3xl shadow-sm border border-dusty-rose/20 max-w-3xl mx-auto" data-id="element-244">
        <h3 className="text-2xl font-serif font-bold text-burgundy mb-8 text-center" data-id="element-245">
          Cada tomo incluye:
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-246">
          {checklist.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-247">
              <CheckCircle2 className="text-green-600 shrink-0 mt-0.5" size={20} data-id="element-248" />
              <span className="text-text-main/90 font-medium" data-id="element-249">{item}</span>
            </div>)}
        </div>
      </div>
    </SectionWrapper>;
}